import { useContext, useEffect, useState } from "react";
import ConfigWrapper from "../../Base/Config/ConfigWrapper";
import ConfigForm from "../../Base/Config/ConfigForm";
import IndexSelector from "../../Base/Config/IndexSelector";
import { propertiesProvince, propertiesSize, propertiesSource } from "../../Base/Config/formDataConstants";
import RunButton from "./RunButton";

const getDates = () => {
    const now = new Date();

    // Get first day of last month
    const firstDayLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);

    // Get last day of last month
    const lastDayLastMonth = new Date(now.getFullYear(), now.getMonth(), 0);

    // Format dates to yyyy-mm-dd
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    return {
        date_from: formatDate(firstDayLastMonth),
        date_to: formatDate(lastDayLastMonth)
    };
};

export default function QueryLinkedinProfilesForCoursesConfig() {
    return <ConfigWrapper
    // defaultIndexName="tracking"  # multiple indices needed
    >
        <ConfigForm
            schema={{
                "type": "object",
                "properties": {
                    group_by: {
                        "type": "array",
                        "title": "group_by",
                        "items": {
                            "type": "string",
                            "enum": ["url_value", "landing_page", "client_id", "degree", "geoip.country_iso_code", "geoip.region_iso_code", "geoip.region_name", "device", "kanton", "hour", "dayOfWeek", "date"],
                        },
                        "uniqueItems": true
                    },
                    client_ids: {
                        "type": "array",
                        "title": "client_ids",
                        "items": {
                            "type": "string",
                            "enum": [
                                "abbts-ch",
                                "anyweb-training-ch",
                                "bsd-bern-ch",
                                "bke-ch",
                                "ffzh-ch",
                                "freisschulen-ch",
                                "gastro-zuerich",
                                "hds-ch",
                                "klubschule-pro-ch",
                                "ost-ch",
                                "physioschule-ch",
                                "phw-ch",
                                "shl-ch",
                                "sts-edu",
                                "studioeins-ch",
                                "supsi-landquart-ch",
                                "swissaccounting-org",
                                "weiterbildung-wba-ch",
                                "zentrumbildung-ch",
                                "zhaw-ch",
                            ],
                        },
                        "uniqueItems": true
                    },
                    "date_from": {
                        "type": "string",
                        "format": "date"
                    },
                    "date_to": {
                        "type": "string",
                        "format": "date"
                    },
                    "has_campaign": {
                        "type": "string",
                        "title": "has_campaign (clicks)",
                        "enum": [true, false]
                    },
                    utm_sources: {
                        "type": "array",
                        "items": {
                            "type": "string",
                            "enum": ["N/A", "google", "linkedin", "perplexity", "chatgpt.com", "instagram"],
                            "enumNames": ["N/A", "google", "linkedin", "perplexity", "chatgpt.com", "instagram"],
                        },
                        "uniqueItems": true
                    },
                    hide_fields: {
                        "type": "array",
                        "items": {
                            "type": "string",
                            "enum": ["title", "degree", "url", "bucket_key", "item_id", "impressions", "clicks", "ctr", "pvalue", "client_id"],
                        },
                        "uniqueItems": true
                    },
                }

            }}
            uiSchema={{
                "group_by": {
                    "ui:widget": "checkboxes"
                },
                "client_ids": {
                    "ui:widget": "checkboxes"
                },
                "utm_sources": {
                    "ui:widget": "checkboxes"
                },
                "hide_fields": {
                    "ui:widget": "checkboxes"
                },
                'ui:order': [
                    "group_by",
                    "client_ids",
                    "date_from",
                    "date_to",
                    "has_campaign",
                    "utm_sources",
                    "hide_fields"
                ]
            }}
            defaultFormData={() => {
                const { date_from, date_to } = getDates();
                return {
                    group_by: ["client_id", "url_value"],
                    client_ids: ["ost-ch"],
                    date_from,
                    date_to,
                    has_campaign: true,
                    utm_sources: [],
                    hide_fields: ["pvalue", "item_id", "bucket_key"]
                };
            }}
            className="rjsf_QueryLinkedinProfilesSelectorConfig"
        />
        <RunButton />
    </ConfigWrapper>
}


